module.exports = {
  module: angular.module('msi.products.price.controller', []).name,
  name: 'PriceController'
};

class PriceController {
  static get $inject() {
    return ['$filter', 'ogsdk.lego'];
  }

  constructor($filter, ogsdk) {
    this.ogsdk = ogsdk;
    this.$filter = $filter;
    this.currencySymbol = this.$filter('translate')('CURRENCY_SYMBOL');
  }

  setPrices(prices) {
    this.baseUnitPrice = prices.baseUnitPrice;
    this.finalUnitPrice = prices.finalUnitPrice;
    this.price = prices.price;
    this.showOriginalPrice = this.checkDifference();
  }

  checkDifference() {
    return Math.abs(this.baseUnitPrice - this.finalUnitPrice) > 0.0001;
  }

  $onInit() {
    return this.setPrices(this.item);
  }
}

angular.module(module.exports.module)
  .controller(module.exports.name, PriceController);
